if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if(document.querySelector("#user-width") != null){
        if(document.querySelector("#user-width").value <= 0 && document.querySelector('variant-radios input[value="Sample"]').checked != true) {
          if(document.querySelector("#user-width").placeholder == 'Multiple' && document.querySelector("#user-width-w1").value > 0){
          } else {
            this.querySelector('.width-error').classList.remove("hidden")
            return;
          }
        }
        this.querySelector('.width-error').classList.add("hidden")
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if(document.querySelector('.button__sample-add-to-cart') != null && document.querySelector('variant-radios input[value="Sample"]').checked == true){
        const sample_button = document.querySelector('.button__sample-add-to-cart')
        sample_button.setAttribute('aria-disabled', true);
        sample_button.classList.add('loading');
        sample_button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }
      
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if(document.querySelector("#user-width") != null){
        if(document.querySelector("#user-width").placeholder == 'Multiple'){
          // add together widths
          console.log('is a multi wall')
          // formData.set('properties[Width]','New width value')
        }
      }
      
      if(typeof(upload_file) !== 'undefined'){
        formData.append('properties[Your ' + color_spelling + 's]', upload_file, 'image.png');
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      
      if(document.querySelector('.quantity__input') == null){var q=1;} else {var q=document.querySelector('.quantity__input').value}
      config.body = formData;
      window.dataLayer = window.dataLayer || [];                                            
      window.dataLayer.push({
        'page_type': 'product',
        'event': 'addtocart',
        'currency': Shopify.currency.active,
        'transactionTotal': (q * parseInt(document.querySelector(".price-item--sale").innerHTML.replaceAll(' ','').replaceAll('\n','').replaceAll(pre,'').replaceAll('.','').replaceAll(',','')) / 100).toFixed(2),
        'productID': productID,
      });
      // fbq('track', 'AddToCart', {
      //   value: (q * parseInt(document.querySelector(".price-item--sale").innerHTML.replaceAll(' ','').replaceAll('\n','').replaceAll(pre,'').replaceAll('.','').replaceAll(',','')) / 100).toFixed(2),
      //   currency: Shopify.currency.active
      // });
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if(typeof(sample_button) != 'undefined'){
            sample_button.classList.remove('loading');
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
            if(typeof(sample_button) != 'undefined'){
              sample_button.removeAttribute('aria-disabled');
            }
          }
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if(typeof(sample_button) != 'undefined'){
            sample_button.querySelector('.loading-overlay__spinner').classList.add('hidden');
            try{
              if(radios[1].value == 'Sample') {
                document.querySelector('variant-radios input[value="'+orig_height_val+'"]').checked = true;
              }
            } catch(e){}
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
